import React from 'react'
import { setKeyword, setResults, setTotalCount, setLoading, setFullResults } from '../store/searchSlice'
import { getSearchResults } from '../../utils/Searchanise'
import { getProductsByHandles } from '../../utils/Product'
import { useSelector, useDispatch } from 'react-redux'

const InlineSearch = () => {
  const dispatch = useDispatch()
  const { keyword, resultItems, totalCount, loading } = useSelector((state) => state.search)
  const keyThreshold = 500 // If there are no key events within 500ms, then get results feed.
  const perPage = 5
  
  const searchString = (e) => {
    clearTimeout(window.keyTimer)
    
    window.keyTimer = setTimeout(() => {
      if(e.target.value.length != 0) {
        dispatch(setLoading(true))
        getSearchResults((response) => {
          console.log(response)
          getProductsByHandles((results) => {
            dispatch(setKeyword(e.target.value))
            dispatch(setResults(results.slice(0,4)))
            dispatch(setTotalCount(response.totalItems))
            dispatch(setFullResults(results))
            setTimeout(() => {
              dispatch(setLoading(false))
              window.setupProductTiles(document.querySelectorAll('[product-tile]:empty'))
            }, 50)
          }, response.items.slice(0,perPage).map((item) => `"${item['link'].replace('/products/', '')}"`))
        }, e.target.value)
      } else {
        dispatch(setKeyword(''))
      }
    }, keyThreshold)
  }
  document.querySelectorAll('[data-search-box]').forEach((box) => box.focus())
  
  return (
    <div className='h-full flex flex-col overflow-auto'>
      <form className="flex items-center justify-between gap-4 border-b border-second lg:pt-4 pb-3 mb-6 lg:mb-10 relative" action="/search" method="get">
        <input className="appearance-none text-base text-black leading-6 placeholder:text-black outline-none grow !outline-none" 
          type="text" 
          name="q" 
          placeholder="Search"
          autoFocus={true}
          onKeyUp={(e) => searchString(e)}
          data-search-box />
        <input name="type" type="hidden" value="product"></input>
        {loading && <span className='search-loader absolute right-16 top-5' />}
        <button className="font-tinos text-base leading-6 text-black">Submit</button>
      </form>
      <div className={resultItems.length > 0 ? 'grow' : ''} data-search-results>
        {resultItems.length > 0 &&
          <div className='flex flex-col justify-between items-end h-full'>
            <div className='w-full'>
              <ul
                className='predictive-search-results grid grid-cols-2 gap-x-3 gap-y-6 lg:gap-x-4 lg:gap-y-10 w-full'
                role='listbox' aria-labelledby='predictive-search-products'
              >
                {resultItems.map((result, index) => 
                  <li role='option' key={`inline-search-${result.id}-${index}`}>
                    <div className='h-full' product-tile='true' props={JSON.stringify(result).replace("'", "’")}></div>
                  </li>
                  )
                }
              </ul>
            </div>
            <a className='!text-black no-underline' href={`/search?q=${keyword}`}>
              <span className='focus-link !text-black'>View All</span>
              &nbsp;
              <sup className='!text-black'>{totalCount}</sup>
            </a>
          </div>
        }
        {resultItems.length == 0 && keyword != '' && <div class="text-base text-black mb-6">No results found for “{ keyword }”. try one of these searches instead:</div>}
      </div>
      {
        resultItems.length == 0 &&
        <ul className="flex flex-col gap-3" data-search-presets>
          <li className='font-medium text-black'>Search Suggestions:</li>
          {
            window.searchPresets.map((preset, index) => 
              <li key={`search-preset-${index}`}>
                <a className="text-base leading-6 hover:underline text-black hover:text-black" href={ preset.url }>{ preset.title }</a>
              </li>
            )
          }
        </ul>
      }
    </div>
  )
}

export default InlineSearch